module.exports = __webpack_public_path__ + "img/ic_property_detached.a1a6bba0.svg";